import styled from "styled-components";
import {
  SkeletonBlock,
  SkeletonCircle,
} from "../../skins/neo/NeoStyles";

const Container = styled.div`
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  gap: ${(p) => (p.$compact ? "10px" : "18px")};
`;

const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${(p) => (p.$compact ? "12px" : "18px")};
  padding: ${(p) => (p.$compact ? "12px 14px" : "20px 24px")};
  border-radius: ${(p) => (p.$compact ? "8px" : "14px")};
  background: #fff;
  box-shadow: ${(p) =>
    p.$compact
      ? "0 1px 6px rgba(60, 90, 130, 0.08)"
      : "0 2px 12px rgba(60, 90, 130, 0.08)"};
`;

const IconGroup = styled.div`
  display: flex;
  gap: 6px;
  margin-left: auto;
`;

/**
 * Placeholder for payment method routing while catalog/routing is loading.
 * Matches the compact Neo hosted-page payment row shape.
 */
const PaymentMethodsSkeleton = ({ compact = false, rows = 2, showTitle = true }) => (
  <Container $compact={compact} aria-busy="true" aria-label="Loading payment methods">
    {showTitle && (
      <SkeletonBlock $h={compact ? "15px" : "18px"} $w="62%" $mb={compact ? "10px" : "15px"} />
    )}
    {Array.from({ length: rows }).map((_, index) => (
      <OptionRow key={index} $compact={compact}>
        <SkeletonCircle $size={compact ? "18px" : "22px"} />
        <SkeletonBlock $h={compact ? "14px" : "16px"} $w={index === 0 ? "38%" : "32%"} />
        <IconGroup>
          <SkeletonBlock $h={compact ? "18px" : "22px"} $w={compact ? "28px" : "34px"} $r="4px" />
          <SkeletonBlock $h={compact ? "18px" : "22px"} $w={compact ? "28px" : "34px"} $r="4px" />
        </IconGroup>
      </OptionRow>
    ))}
  </Container>
);

export default PaymentMethodsSkeleton;
